<template>
    <svg width="26" height="70" viewBox="0 0 26 70" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2019_1263)">
<path d="M12.82 20.7C18.5361 20.7 23.17 16.0661 23.17 10.35C23.17 4.63385 18.5361 0 12.82 0C7.10382 0 2.46997 4.63385 2.46997 10.35C2.46997 16.0661 7.10382 20.7 12.82 20.7Z" fill="#006AB2"/>
<path d="M20.59 24.3899H5.04C2.26 24.3899 0 26.6499 0 29.4299V53.0599C0 55.0599 1.17 56.7799 2.85 57.5899V64.8099C2.85 67.5899 5.11 69.8499 7.89 69.8499H17.74C20.52 69.8499 22.78 67.5899 22.78 64.8099V57.5899C24.46 56.7699 25.63 55.0499 25.63 53.0599V29.4299C25.63 26.6499 23.37 24.3899 20.59 24.3899Z" fill="#006AB2"/>
</g>
<defs>
<clipPath id="clip0_2019_1263">
<rect width="25.63" height="69.86" fill="white"/>
</clipPath>
</defs>
</svg>
</template>